import { Typography } from '@mui/material'

export const ComponentCrashed = () => (
  <Typography variant='h4' color='error'>
    The component crashed. Please report it to the dev team.
  </Typography>
)
